/** @typedef {"undiscovered" | "faded" | "active"} EvolutionTierVisualState */

export const EVOLUTION_TIER_UNDISCOVERED = "undiscovered";
export const EVOLUTION_TIER_FADED = "faded";
export const EVOLUTION_TIER_ACTIVE = "active";

/**
 * @param {number} tierId
 * @param {Record<number, boolean>} unlockedTiers persistent collection unlocks
 * @param {number|null|undefined} currentRunMaxTierId highest tier merged this run
 * @returns {EvolutionTierVisualState}
 */
export function getEvolutionTierVisualState(tierId, unlockedTiers, currentRunMaxTierId) {
  var id = Math.floor(Number(tierId) || 0);
  if (!unlockedTiers || !unlockedTiers[id]) return EVOLUTION_TIER_UNDISCOVERED;
  var runMax = currentRunMaxTierId != null ? Math.floor(Number(currentRunMaxTierId) || 0) : 0;
  if (id > runMax) return EVOLUTION_TIER_FADED;
  return EVOLUTION_TIER_ACTIVE;
}

/**
 * CSS class suffixes for ring nodes / dock chips.
 * @param {EvolutionTierVisualState} state
 * @returns {string}
 */
export function evolutionTierVisualClass(state) {
  if (state === EVOLUTION_TIER_UNDISCOVERED) return "evolution-tier--undiscovered";
  if (state === EVOLUTION_TIER_FADED) return "evolution-tier--faded";
  return "evolution-tier--active";
}

/**
 * Run-high marker: ring hub (dial) or strip chip (vertical layout).
 * @param {number} tierId
 * @param {EvolutionTierVisualState} visual
 * @param {number|null|undefined} currentRunMaxTierId
 */
export function isRunMaxTierChip(tierId, visual, currentRunMaxTierId) {
  if (visual !== EVOLUTION_TIER_ACTIVE) return false;
  if (currentRunMaxTierId == null) return false;
  return Math.floor(Number(tierId) || 0) === Math.floor(Number(currentRunMaxTierId) || 0);
}
